import { Links, Meta, Outlet, Scripts } from "react-router";
import "styles/app.css";
import React from "react";
import MainLayout from "components/layout/MainLayout";

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="pt-br">
      <head>
        <link rel="icon" type="image/png" href="/logo.png" />
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <script src="https://in.nett.dev/js/script.js" data-domain="maragogiaomar.com.br" />
        <script>
        {`
          window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) }
        `}
        </script>
        <script src="https://www.googletagmanager.com/gtag/js?id=G-GGTK48F7DV" />
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'AW-715549834');
            gtag('config', 'G-GGTK48F7DV');
          `}
        </script>
        <script>
          {`
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "r9plfmkg4s");
          `}
        </script>
        <Meta />
        <Links />
      </head>
      <body>
        <MainLayout>
          {children}
        </MainLayout>
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  return <Outlet />;
}
